import * as yup from 'yup';

export const basicDetailsFormSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  contact: yup.string().required('Contact is required'),
  district: yup.string().required('District is required'),
});
